// SEO Keywords Strategy - Ultra-optimized keyword mapping
export const SEO_KEYWORDS = {
  // Primary keywords by category
  categories: {
    'nature': {
      primary: ['sons nature gratuits', 'bruits nature mp3', 'ambiance nature libre droits'],
      longTail: [
        'télécharger sons nature gratuits mp3',
        'bruits oiseaux forêt gratuits',
        'ambiance relaxation nature libre droits',
        'sons eau rivière cascade gratuits',
        'bruitages animaux sauvages mp3',
        'atmosphère nature méditation gratuite'
      ],
      intent: ['relaxation', 'méditation', 'bien-être', 'documentaire nature', 'jeux vidéo nature']
    },
    'effets-sonores': {
      primary: ['effets sonores gratuits', 'bruitages mp3 libres', 'sound effects free'],
      longTail: [
        'effets sonores explosion gratuits mp3',
        'bruitages cartoon animation libre droits',
        'sound effects jeux vidéo gratuits',
        'effets transition vidéo mp3',
        'bruitages film gratuits télécharger',
        'effets spéciaux audio libres droits'
      ],
      intent: ['montage vidéo', 'animation', 'jeux vidéo', 'podcast', 'film indépendant']
    },
    'ambiance': {
      primary: ['ambiances sonores gratuites', 'atmosphères audio mp3', 'fonds sonores libres'],
      longTail: [
        'ambiance café restaurant gratuite mp3',
        'atmosphère ville urbaine libre droits',
        'fond sonore bureau travail gratuit',
        'ambiance halloween effrayante mp3',
        'atmosphère espace science fiction gratuite',
        'sons ambiance nuit mystérieuse'
      ],
      intent: ['immersion', 'concentration', 'ambiance travail', 'création contenu', 'relaxation']
    }
  },

  // High-volume commercial keywords
  commercial: [
    'sons gratuits téléchargement',
    'mp3 libre droits commercial',
    'bruitages gratuits usage commercial',
    'fichiers audio libres droits',
    'sons royalty free français',
    'bibliothèque audio gratuite',
    'sound library free download',
    'audio files commercial use free'
  ],

  // Location-based keywords (French market)
  geo: [
    'sons gratuits france',
    'bruitages français mp3',
    'effets sonores québec',
    'ambiances sonores belgique',
    'sons libres droits francophone'
  ],

  // Trending/seasonal keywords
  trending: [
    'sons asmr gratuits 2025',
    'bruitages tiktok libres droits',
    'effets sonores youtube gratuits',
    'sons podcast intro gratuits',
    'ambiances streaming twitch'
  ]
};

// SEO-optimized URL slugs with keywords
export const generateSEOSlug = (title, category, subcategory) => {
  const baseSlug = title
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .trim('-');

  // Add category context for better SEO
  const categoryMap = {
    'nature': 'nature',
    'effets-sonores': 'effet-sonore',
    'ambiance': 'ambiance'
  };

  const categorySlug = categoryMap[category] || category;
  
  // For sounds, include category in slug for better keyword targeting
  if (subcategory) {
    return `${baseSlug}-${subcategory}-gratuit`;
  }
  
  return `${baseSlug}-${categorySlug}-gratuit`;
};

// Meta title templates optimized for CTR and SEO
export const META_TITLE_TEMPLATES = {
  sound: (title, category) => `${title} Gratuit MP3 WAV - Téléchargement Libre de Droits | SoundNest`,
  category: (category) => `Sons ${category} Gratuits MP3 - Téléchargement Libre de Droits | SoundNest`,
  subcategory: (category, subcategory) => `Sons ${subcategory} ${category} Gratuits - Collection MP3 WAV | SoundNest`,
  homepage: 'Sons Gratuits MP3 WAV - Plus de 600 Fichiers Libres de Droits | SoundNest'
};

// Meta description templates with strong CTAs
export const META_DESC_TEMPLATES = {
  sound: (title, category, duration) => 
    `Téléchargez "${title}" gratuitement en MP3 et WAV. Son ${category} libre de droits (${duration}). ✓ Usage commercial autorisé ✓ Qualité professionnelle ✓ Téléchargement immédiat.`,
  
  category: (category, count) => 
    `Découvrez ${count}+ sons ${category} gratuits en MP3 et WAV. Téléchargement libre de droits pour vos projets. ✓ Qualité studio ✓ Usage commercial ✓ Mise à jour quotidienne.`,
  
  homepage: 'Plus de 600 sons gratuits libres de droits en MP3 et WAV. Bruitages, ambiances, effets sonores pour vos projets créatifs. ✓ Téléchargement gratuit ✓ Usage commercial autorisé.'
};

// Rich keywords for specific use cases
export const USE_CASE_KEYWORDS = {
  'youtube': ['sons youtube gratuits', 'musique libre droits youtube', 'bruitages youtube mp3'],
  'tiktok': ['sons tiktok gratuits', 'effets sonores tiktok', 'audio tiktok libre droits'],
  'podcast': ['intro podcast gratuit', 'jingle podcast mp3', 'transition podcast audio'],
  'jeux-video': ['sons jeux vidéo gratuits', 'bruitages game audio', 'effets sonores gaming'],
  'montage-video': ['sons montage vidéo', 'bruitages film gratuits', 'effets transition vidéo'],
  'meditation': ['sons méditation gratuits', 'ambiance relaxation mp3', 'bruits nature zen']
};

export default SEO_KEYWORDS;
